import { jsx as _jsx } from "react/jsx-runtime";
import { CSpinner } from "@coreui/react";
const PageLoader = () => {
    return (_jsx("div", Object.assign({ className: "pt-3 text-center d-flex align-items-center justify-content-center" }, { children: _jsx(CSpinner, { color: "primary", style: { width: "8rem", height: "8rem" } }) })));
};
export default PageLoader;
